import firebase from "firebase/app";
import { v4 as uuidv4 } from "uuid";
import { message } from "antd";

type PromiseCallback = (value?: any) => void;

const fetchAllCourtsAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { branchId } = payload;
  firebase
    .firestore()
    .collection("courts")
    .where("branchId", "==", branchId)
    .orderBy("name", "asc")
    .get()
    .then((querySnapshot) => {
      const allCourts = querySnapshot.docs.map((doc) => doc.data());
      resolve(allCourts);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error fetch courts: ", error);
      message.error("Something went wrong!");
      reject(error);
    });
};

const createCourtAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { name, place, branchId, description } = payload;
  const currentTime = new Date().toISOString();
  const newCourt = {
    courtId: uuidv4(),
    name,
    place,
    description,
    branchId,
    createdAt: currentTime,
    updatedAt: currentTime,
  };
  firebase
    .firestore()
    .collection("courts")
    .doc(newCourt.courtId)
    .set(newCourt)
    .then(() => {
      message.success("New court has been created successful!");
      resolve(newCourt);

    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error adding document: ", error);
      message.error("Something went wrong! Please try again later!");
      reject(error);
    });
};

const updateCourtAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { courtId, name, description, place, branchId } = payload;
  const currentTime = new Date().toISOString();
  firebase.firestore().collection("courts").doc(courtId).update({
    name,
    description,
    place,
    updatedAt: currentTime,
  });
  firebase
    .firestore()
    .collection("courts")
    .where("branchId", "==", branchId)
    .get()
    .then((querySnapshot) => {
      const allCourts = querySnapshot.docs.map((doc) => doc.data());
      message.success("Court has been updated successful!");
      resolve(allCourts);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error fetch clubs: ", error);
      message.error("Something went wrong! Please try again later!");
      reject(error);
    });
};

const deleteCourtAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { court } = payload;
  firebase
    .firestore()
    .collection("courts")
    .doc(court.courtId)
    .delete()
    .then(() => {
      firebase
        .firestore()
        .collection("courts")
        .where("branchId", "==", court.branchId)
        .get()
        .then((querySnapshot) => {
          const allCourts = querySnapshot.docs.map(doc => doc.data());
          message.success("Court has been deleted!");
          resolve(allCourts);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Error fetch courts: ", error);
          message.error("Something went wrong! Please try again later!");
          reject(error);
        });
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error("Error removing document: ", e);
      reject(e);
    });
};

const fetchAvailableCourtsAPI = () => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  // eslint-disable-next-line no-console
  firebase
    .firestore()
    .collection("courts")
    .get()
    .then((querySnapshot) => {
      const allCourts = querySnapshot.docs.map(doc => ({ ...doc.data(), key: doc.id }));
      resolve(allCourts);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error fetch courts: ", error);
      reject(error);
    });
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseFetchAllCourts = (payload: any): any =>
  new Promise(fetchAllCourtsAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseCreateCourt = (payload: any): any =>
  new Promise(createCourtAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseEditCourt = (payload: any): any =>
  new Promise(updateCourtAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseDeleteCourt = (payload: any): any =>
  new Promise(deleteCourtAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseFetchAvailableCourts = (): any =>
  new Promise(fetchAvailableCourtsAPI());
